import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { FileDown, Ticket, TicketCheck, XCircle } from "lucide-react";
import MapPin from "@/Components/Icons/MapPin.tsx";
const S3_URL = import.meta.env.VITE_S3_URL;

export type CardInvitationProps =
  | {
  withCancel: true;
  item: any;
  rewardText: any;
  handleDownloadPdf: (id: string) => void;
  handleOpenModal: (id: string) => void;
  handleOpenModalAttended: (id: string) => void;
  handleOpenModalPackage: (id: string) => void;
  handleOpenCancelModal: (id: string) => void;
  reservationData: any;
}
  | {
  withCancel?: false;
  item: any;
  rewardText: any;
  handleDownloadPdf: (id: string) => void;
  handleOpenModal: (id: string) => void;
  handleOpenModalAttended: (id: string) => void;
  handleOpenModalPackage: (id: string) => void;
  handleOpenCancelModal?: never;
  reservationData: any;
};

const CardInvitation = (props: CardInvitationProps) => {
  return (
    <div
      className="flex gap-3 mt-2 overflow-hidden transition-shadow border-b pb-2 mx-3"
    >
      <div className="w-full flex">
        <Link
          to={`/detailPage/${props.item.campaign_id}`}
          className="w-10/12 flex"
        >
          <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-lg">
            <img
              src={`${S3_URL}${props.item.thumbnail}`}
              alt={props.item.title}
              className="object-cover w-full h-full"
            />
          </div>

          <div className="pl-2 max-w-[calc(100%-8rem)] flex flex-col ">
            <div>
              <h3 className="font-bold text-[13px] text-gray-800 line-clamp-1">
                {props.item.title || "제목 없음"}
              </h3>
              {/* <div className="flex text-[9px] mt-2">
                          <p className="font-medium">신청 {props.item.real_apply}</p>
                          <p className="text-[#999999]">
                            / 모집 {props.item.max_apply}
                          </p>
                        </div> */}
              <p className="text-[11px] pt-1 text-[#999999] line-clamp-2 w-full">
                {props.rewardText || "설명 없음"}
              </p>
            </div>
            <div className="text-[8px] ">
              {props.item.reservation_dtm &&
                props.item.reservation_status !== "취소됨" && (
                  <p className="text-[10px] pt-1 truncate w-full text-green-500">
                    예약:{" "}
                    {dayjs(props.item.reservation_dtm).format("M월 D일")}{" "}
                    {dayjs(
                      `${props.item.reservation_dtm} ${props.item.reservation_time}`
                    ).format("A h시 mm분")}
                  </p>
                )}
              {props.item.reservation_status === "취소됨" && (
                <p className="text-[10px] pt-1 truncate w-full text-red-500">
                  예약: 취소됨
                </p>
              )}
            </div>
          </div>
        </Link>

        <div className="w-2/12 flex flex-col items-end justify-between gap-1">
          {props.item.reservation_status !== "취소됨" && props.withCancel && (
            <button
              className="flex items-center   gap-2 text-[9px]  bg-[#fe7070] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
              onClick={() => props.handleOpenCancelModal?.(props.item)}
            >
              <XCircle width={12} />
              <div className="flex px-1 justify-between">
                <div>취</div>
                <div>소</div>
              </div>
            </button>
          )}
          {props.item.path_winner_file && (
            <button
              onClick={() => props.handleDownloadPdf(props.item.path_winner_file)}
              className="flex items-center gap-2 text-[9px] hover:bg-gray-400 bg-[#ff88e3] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
            >
              <FileDown width={12} />
              가이드
            </button>
          )}

          {props.item.campaign_type === "배송형" && <button
            className="flex items-center gap-2 text-[9px] hover:bg-[#70d6ed] bg-[#46B6D0] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
            onClick={() => props.handleOpenModalPackage(props.item)}
          >
            <MapPin width={12} height={24}/>
            배송지
          </button>
          }
          {/* 1. 예약일 버튼 (jika campaign pakai sistem 예약/reservation dan belum ada 예약 날짜) */}
          {props.item.is_reservation &&
            props.reservationData[props.item.campaign_id] &&
            !props.item.reservation_dtm && (
              <button
                className="flex items-center gap-2 text-[9px] hover:bg-[#70d6ed] bg-[#46B6D0] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
                onClick={() => props.handleOpenModal(props.item)}
              >
                <Ticket width={12} />
                예약일
              </button>
            )}

          {/* 2. 초대권 버튼 (kondisi sesuai requirement terbaru) */}
          {props.item.campaign_type !== "배송형" &&
            props.reservationData[props.item.campaign_id] &&
            !props.item.is_attend &&
            (props.item.reservation_status === "완료" ||
              (!props.item.is_reservation &&
                props.item.reservation_status === "대기 중")) && (
              <button
                className="flex items-center gap-2 text-[9px] hover:bg-[#70d6ed] bg-[#5483c8] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
                onClick={() => props.handleOpenModalAttended(props.item)}
              >
                <TicketCheck width={12} />
                초대권
              </button>
            )}
        </div>
      </div>
    </div>
  );
};

export default CardInvitation;